import { gql } from '@apollo/client';

export const EXTRACT_PORTFOLIO_DETAILS = gql`
  query EXTRACT_PORTFOLIO_DETAILS($url: String!) {
    extractPortfolioDetailsFromLink(url: $url) {
      title
      description
      thumbnail
      genres
      tags
      teamMembers
      videoUrl
    }
  }
`;
